import { Decoration,MatchDecorator, WidgetType, ViewPlugin, ViewUpdate, DecorationSet, EditorView } from "@codemirror/view";

// 定义一个小部件
class PlaceholderWidget extends WidgetType {
    constructor(readonly name: string) {
        super();
    }

    eq(other: PlaceholderWidget) {
        return other.name === this.name;
    }

    toDOM() {
        const span = document.createElement("span");
        span.className = "placeholder-widget";
        span.textContent = this.name;
        span.style.color = "red";
        span.style.border = "1px solid red";
        span.style.padding = '2px 4px';
        return span;
    }

    ignoreEvent() {
        return false;
    }
}

// 定义匹配装饰器
const placeholderMatcher = new MatchDecorator({
    regexp: /\[\[([^\[\]]+)\]\]/g,
    decoration: match => Decoration.replace({
        widget: new PlaceholderWidget(match[1]),
        inclusive: true,

    })
})

const placeholderPlugin = ViewPlugin.fromClass(class {
    decoration: DecorationSet
    constructor(view: EditorView) {
        this.decoration = placeholderMatcher.createDeco(view)
    }
    update(update: ViewUpdate) {
        this.decoration = placeholderMatcher.updateDeco(update, this.decoration)
    }
}, {
    decorations: instance => instance.decoration,
    provide: plugin => EditorView.atomicRanges.of(view => {
        const decorations = view.plugin(plugin)?.decoration || Decoration.none;

        return decorations;
    })
})

export default placeholderPlugin;
